import { authenticatedFetch, publicFetch } from './request';

function normalizeCityListResponse(data) {
    if (Array.isArray(data)) return data;
    if (data && typeof data === 'object') {
        if (Array.isArray(data.data)) return data.data;
        if (Array.isArray(data.cities)) return data.cities;
        if (Array.isArray(data.items)) return data.items;
        if (Array.isArray(data.result)) return data.result;
    }
    return [];
}

export default async function getCity(setErrorMessage) {
    const onError = () => setErrorMessage && setErrorMessage('No se puede obtener las ciudades.');

    let raw = await authenticatedFetch('/cities/getList', onError);
    let list = normalizeCityListResponse(raw);

    const authFailed =
        raw &&
        typeof raw === 'object' &&
        (raw.status === 401 || raw.message === 'Not Authenticated');

    if (list.length === 0 && authFailed) {
        raw = await publicFetch('/cities/getList', onError);
        list = normalizeCityListResponse(raw);
    }

    return list;
}
